<template>
  <div>
    <Modal @closeModal="$emit('closeTriggered')">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="font-weight-bold">CROP PHOTO</span>
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body">
        <div class="container px-1">
          <div class="row">
            <div class="col-12">
              <!-- CROP SECTION -->
              <div class="image-crop w-100 h-auto" id="croppieBox"></div>
              <!-- CROP SECTION -->

              <!-- CROP SHAPED INSTANCE  -->
              <div class="crop-shapes" v-if="false">
                <div
                  class="icon"
                  title="Square crop"
                  :class="current_shape === 'square' ? 'selected' : null"
                  @click="configureBoundarySize('square')"
                >
                  <img v-lazy="localImg('square.svg')" alt="" />
                </div>

                <div
                  class="icon"
                  title="Rectangle crop"
                  :class="current_shape === 'rectangle' ? 'selected' : null"
                  @click="configureBoundarySize('rectangle')"
                >
                  <img v-lazy="localImg('rectangle.svg')" alt="" />
                </div>

                <div
                  class="icon"
                  title="Circle crop"
                  :class="current_shape === 'circle' ? 'selected' : null"
                  @click="configureBoundarySize('circle')"
                >
                  <img v-lazy="localImg('circle.svg')" alt="" />
                </div>
              </div>

              <div
                class="button-row d-flex justify-content-center align-items-center mt-3 mb-0 pt-1"
              >
                <button
                  class="btn btn-md btn-accent brand_navy"
                  @click="cropPhoto"
                  ref="cropBtn"
                >
                  Crop Photo
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Croppie from "croppie";
import Modal from "@/components/globalComps/Modal";
import { setTimeout } from "timers";

export default {
  name: "PhotoCropModal",

  components: {
    Modal,
  },

  props: ["crop_photo", "orientation", "photo_check"],

  mounted() {
    this.image = this.crop_photo;
    this.setupCrop();
  },

  data() {
    return {
      image: null,
      croppie: null,
      viewport_width: 280,
      viewport_height: 330,
      boundary_width: 400,
      boundary_height: 400,
      type: "square",

      current_shape: "square",
    };
  },

  methods: {
    dropModal() {
      this.$emit("closeTriggered");
    },

    configureBoundarySize(shape) {
      this.current_shape = shape;

      if (shape === "square") this.sizeSetup();
      else if (shape === "rectangle") this.sizeSetup("square", 240, 280);
      else if (shape === "circle") this.sizeSetup("circle");
    },

    sizeSetup(type = "square", view_width = 240, view_height = 240) {
      this.$nextTick(() => {
        this.viewport_width = view_width;
        this.viewport_height = view_height;
        this.boundary_width = 360;
        this.boundary_height = 360;
        this.type = type;

        this.setupCrop();
      });
    },

    setupCrop() {
      this.setOrientation();
      let cropBox = document.getElementById("croppieBox");
      this.croppie = new Croppie(cropBox, {
        viewport: {
          width: this.viewport_width,
          height: this.viewport_height,
          type: this.type,
        },
        boundary: { width: this.boundary_width, height: this.boundary_height },
        showZoomer: true,
        enableOrientation: true,
      });

      this.croppie.bind({
        url: this.image,
      });
    },

    setOrientation() {
      if (this.orientation === "landscape") {
        this.viewport_width = 420;
        this.viewport_height = 220;
        this.boundary_width = 480;
        this.boundary_height = 280;
      }
    },

    urltoFile(url, filename, mimeType) {
      mimeType = mimeType || (url.match(/^data:([^;]+);/) || "")[1];
      return fetch(url)
        .then(function(res) {
          return res.arrayBuffer();
        })
        .then(function(buf) {
          return new File([buf], filename, { type: mimeType });
        });
    },

    cropPhoto() {
      this.$refs.cropBtn.disabled = true;
      this.$refs.cropBtn.innerHTML =
        '<div class="icon-dotted-roller font-17 mr-2 animate"></div>Cropping...';

      setTimeout(() => {
        this.croppie
          .result({
            type: "canvas",
            size: "viewport",
            format: "png",
            quality: 1,
            square: true,
          })
          .then((base64_res) => {
            // console.log("Cropped", base64_res);

            let response_data = {
              data: base64_res,
              data_type: this.photo_check,
              image: null,
            };

            this.urltoFile(base64_res, "Image_file.png").then((file) => {
              // console.log("Converted file", file);
              response_data.image = file;

              this.$refs.cropBtn.disabled = true;
              this.$refs.cropBtn.innerHTML =
                '<div class="icon-accept font-18 mr-2 "></div>Cropped...';

              if (this.orientation == "landscape")
                this.$emit("updateCroppedLandscapedPhoto", response_data);
              else this.$emit("updateCroppedPhoto", response_data);

              setTimeout(() => {
                this.dropModal();
              }, 2500);
            });
          });
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
.crop-shapes {
  @include flex_row_center_nowrap;
  margin-top: -10px;

  .icon {
    padding: 5px;
    margin: 0 8px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;

    img {
      @include equal_min_edge(24);
    }

    &:hover {
      background: $brand_accent_light;
    }
  }

  .selected {
    background: $brand_accent_light;
  }
}
</style>
